module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/open/314e8f66dd81c793979f49ee8da3b059.png";